import { render } from "./ProfileVersoesTab.vue?vue&type=template&id=4992759a&scoped=true&ts=true"
import script from "./ProfileVersoesTab.vue?vue&type=script&lang=ts"
export * from "./ProfileVersoesTab.vue?vue&type=script&lang=ts"

import "./ProfileVersoesTab.vue?vue&type=style&index=0&id=4992759a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4992759a"]])

export default __exports__